import ProxyUrl from './ProxyUrls';

export const SilentUrls = [ProxyUrl.isSessionActive];

export const SocialMediaURLS = {
    facebook: 'https://www.facebook.com/login/',
    instagram: 'https://www.instagram.com/accounts/login/',
    twitter: 'https://twitter.com/login',
    tiktok: 'https://www.tiktok.com/login'
};

export default { SocialMediaURLS, SilentUrls };